if (process.env.NODE_ENV !== 'production') {
  require('preact/debug')
}

import { IWidgetRuntime, IWidgetRenderer, IWidgetRendererOptions } from '../interfaces'
import { WidgetRenderer } from './renderer'

export function createWidgetRenderer(runtime: IWidgetRuntime, options: IWidgetRendererOptions): IWidgetRenderer {
  return new WidgetRenderer(runtime, options)
}
